module.exports = __webpack_public_path__ + "static/Owain-Service-8efc4207244cbf06f4c405f960cc31a0.jpg";